import passwords from './view/component/passwords.vue'
import pages from './view/component/pages.vue'
import others from './view/component/others.vue'
import heads from './view/component/heads.vue'
import backs from './view/component/backTime.vue'
import timelabel from './view/component/timeLabel.vue'
import date from './view/component/date.vue'
import share from './view/component/share.vue'
import imgCode from './view/component/imgCode.vue'

let components = {
    passwords:passwords,
    pages:pages,
    others:others,
    heads:heads,
    backs:backs,
    timelabel:timelabel,
    date:date,
    share:share,
    imgCode:imgCode
}

export default components


// WEBPACK FOOTER //
// ./src/components.js